import { SettingsData, SofaRange } from 'sofa-reborn-react';
import {
	SET_SETTINGS,
	SET_SOFA_RANGE,
	SET_FEATURES,
	SettingsStateActions,
	SET_KOMPIS_SETTINGS,
} from './types';
import { IDexfSettings } from '@inter-ikea-kompis/types';

export function setSettings(value: SettingsData): SettingsStateActions {
	return {
		type: SET_SETTINGS,
		value,
	};
}

export function setSofaRange(value: SofaRange): SettingsStateActions {
	return {
		type: SET_SOFA_RANGE,
		value,
	};
}

export function setFeatures(value: string[]): SettingsStateActions {
	return {
		type: SET_FEATURES,
		value,
	};
}

export function setKompisSettings(value: IDexfSettings): SettingsStateActions {
	return {
		type: SET_KOMPIS_SETTINGS,
		value,
	};
}
